import { ToastChakra } from "../helpers/toast";
import api from "../helpers/api";

const baseURL = process.env.REACT_APP_API_URL;
const getAllServicios = async (data) => {
    const {page, perPage} = data;
    const response = await api.get(`${baseURL}/servicios/listar?pagina=${page}&cantidadPagina=${perPage}`);
   // console.log('esto trae servicios:', response.data);
    return response.data;  // Aquí obtienes el objeto con `data` y `pagination`
}


const createServicio = async (data) => {
    const response = await api.post(`${baseURL}/servicios/crear`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('SERVICIO CREADO', 'El servicio se ha creado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

// Update
const updateServicio = async (data) => {
    const response = await api.put(`${baseURL}/servicios/actualizar/${data.id}`, data);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('SERVICIO MODIFICADO', 'El servicio se ha modificado correctamente', 'success', 3000, 'bottom-right');
        return response.data
    }
}

// Delete a user

const deleteServicio = async (id) => {

    const response = await api.delete(`${baseURL}/servicios/eliminar/${id}`);
    if (response.status === 200 || response.status === 201) {
        ToastChakra('SERVICIO ELIMINADO', 'El servicio se ha eliminado correctamente', 'success', 3000, 'bottom-right');
        return response.data;
    }
}

const serviciosService = {
    getAllServicios,
    createServicio,
    updateServicio,
    deleteServicio
}

export default serviciosService;